/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const wasteCategory = async (): Promise<any> => {
  const wasteCategory = useJSONStore.getState().wasteCategory;
  const token = useUserStore.getState().userToken;
  const setWasteCat = useJSONStore.getState().setWasteCat;

  if (wasteCategory.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.wasteCategory}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setWasteCat(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default wasteCategory;
